import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component6cards from '../components/component6cards'
import FooterMain from '../components/footer-main'
import './all-projects.css'

const AllProjects = (props) => {
  return (
    <div className="all-projects-container">
      <Helmet>
        <title>Реализованные проекты по роботизации | Arcobo</title>
        <meta
          name="description"
          content="Проекты Arcobo по роботизации производства, WAAM, автоматизации и промышленным роботам. Реальные внедрения, результаты и эффективные решения."
        />
        <meta
          property="og:title"
          content="Реализованные проекты по роботизации | Arcobo"
        />
        <meta
          property="og:description"
          content="Проекты Arcobo по роботизации производства, WAAM, автоматизации и промышленным роботам. Реальные внедрения, результаты и эффективные решения."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Реализованные проекты по роботизации | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Проекты Arcobo по роботизации производства, WAAM, автоматизации и промышленным роботам. Реальные внедрения, результаты и эффективные решения."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/all-projects"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/all-projects"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"AllProjects","item":"https://arcobo.tech/all-projects"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name18"></HeaderMain>
      <Component6cards
        titleAs="h1"
        componentText="Реализованные проекты в области промышленной роботизации, автоматизации и металлической 3D-печати"
        feature1Title="3D-наплавка запорной арматуры"
        feature2Title="Роботизация сварки"
        feature3Title="Паллетирование мешков и бочек"
        feature4Title="3D-печать ракетных сопел"
        feature5Title="3D-печать топливного бака"
        feature6Title="3D-печать рабочих колес"
        rootClassName="component6cardsroot-class-name2"
        componentTitle="Проекты"
        feature1ImageSrc="/Projects/301_tig_cladding-1500w.webp"
        feature1ImageAlt="TIG-наплавка"
        feature2ImageSrc="/Projects/302_welding-300h.webp"
        feature2ImageAlt="Роботизированная сварка"
        feature3ImageSrc="/Projects/303_palletizer-300h.webp"
        feature3ImageAlt="Паллетайзер"
        feature4ImageSrc="/Projects/304_nozzle-1500w.webp"
        feature4ImageAlt="Сопло, изготовленное WAAM-печатью"
        feature5ImageSrc="/Projects/305_tank-300h.webp"
        feature5ImageAlt="Резервуар, изготовленный WAAM-печатью"
        feature6ImageSrc="/Projects/306_impeller_wheel-300h.webp"
        feature6ImageAlt="Крыльчатка, изготовленная WAAM-печатью"
        feature1Description={
          <Fragment>
            <span className="all-projects-thq-feature1-description-elm1 thq-body-small">
              <span>
                Разработан и внедрен роботизированный комплекс для
                восстановления внутренних поверхностей задвижек TIG-методом.
                Производительность увеличена в 25 раз, обеспечено стабильное
                качество наплавки и автоматизированная генерация траектории
                наплавки.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="all-projects-thq-feature1-description-elm2 thq-body-small">
              <span>
                Внедрены роботизированные сварочные комплексы для серийного
                производства. Сокращено влияние человеческого фактора, повышена
                производительность и повторяемость качества сварных соединений.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="all-projects-text14">
              <span>
                Запрограммированы роботизированные комплексы паллетирования для
                строительных смесей и промышленной продукции. Обеспечена
                непрерывная работа линии с минимальным участием персонала.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="all-projects-text17">
              <span>
                Изготовлены и успешно испытаны ракетные сопла из Inconel 718 и
                нержавеющей стали. Срок изготовления сокращен с недель до одного
                дня, стоимость производства снижена в несколько раз.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature5Description={
          <Fragment>
            <span className="all-projects-text20">
              <span>
                Разработана технология изготовления алюминиевого топливного бака
                методом WAAM из сплава АМг61. Получен опытный образец и
                подтверждена возможность применения технологии для научных
                исследований.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature6Description={
          <Fragment>
            <span className="all-projects-text23">
              Разработана технология производства рабочих колес насосов методом
              WAAM. Подготовлена база для локального изготовления изделий из
              нержавеющих и титановых сплавов.
            </span>
          </Fragment>
        }
      ></Component6cards>
      <FooterMain rootClassName="footer-mainroot-class-name18"></FooterMain>
    </div>
  )
}

export default AllProjects
